import { CONTACT } from "../../lib/catalog";

const Row = ({ k, v, shade }) => (
  <tr className={shade ? "bg-[#fbe9f0]" : ""}>
    <td className="w-44 border-b border-[#f1d9e4] px-4 py-2.5 text-[#5a0f4e]">{k}</td>
    <td className="border-b border-[#f1d9e4] px-4 py-2.5 text-[#240620]">{v || "-"}</td>
  </tr>
);

export const OrderNotePreview = ({ o }) => (
  <div className="print-area overflow-hidden rounded-xl bg-[#FEFDEB] text-[15px] text-[#240620] shadow-xl" data-testid="order-note-preview">
    <div className="px-6 pt-8 text-center sm:px-10">
      <img src="/brand/logo-tight.webp?v=4" alt="PetalBasket" className="mx-auto h-28 w-auto" />
      <p className="mt-3 font-display text-xl italic text-[#4a2443]">by LeoFair Events and Entertainment</p>
      <div className="mt-5 rounded-xl bg-[#4a0d40] py-3 font-cinzel text-2xl font-semibold tracking-[0.35em] text-white">ORDER NOTE</div>
    </div>
    <div className="space-y-6 px-6 py-6 sm:px-10">
      <table className="w-full border border-[#ead0dc] bg-white">
        <tbody>
          <Row k="Customer" v={o.customer} />
          <Row k="Occasion" v={o.occasion} />
          <Row k="Event date" v={o.event_date} />
          <Row k="Delivery time" v={o.delivery_time} />
          <Row k="Contact person" v={o.contact_person} />
          <Row k="Phone" v={o.contact_phone} />
          <Row k="Address" v={o.address} />
          <Row k="Status" v={o.status} shade />
        </tbody>
      </table>
      <div>
        <h3 className="mb-2 font-bold text-[#c2185b]">ITEMS</h3>
        <table className="w-full border border-[#ead0dc] bg-white text-left">
          <thead className="bg-[#4a0d40] text-white">
            <tr><th className="px-3 py-2.5">#</th><th className="px-3 py-2.5">Item</th><th className="px-3 py-2.5">Size / Qty</th><th className="px-3 py-2.5">Details</th></tr>
          </thead>
          <tbody>
            {(o.items || []).map((it, i) => (
              <tr key={i} className={i % 2 === 0 ? "bg-[#fbe9f0]" : "bg-white"}>
                <td className="px-3 py-2.5">{i + 1}</td><td className="px-3 py-2.5 font-medium">{it.item}</td>
                <td className="px-3 py-2.5">{it.size}</td><td className="px-3 py-2.5">{it.details}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div>
        <h3 className="mb-2 font-bold text-[#c2185b]">PAYMENT</h3>
        <table className="w-full border border-[#ead0dc] bg-white"><tbody>
          <Row k="Advance" v={o.advance} /><Row k="Total amount" v={o.total_amount} />
        </tbody></table>
      </div>
      {o.notes && <p><span className="font-semibold">Notes:</span> {o.notes}</p>}
    </div>
    <div className="bg-[#4a0d40] px-6 py-5 text-center text-white">
      <p className="text-2xl font-bold">{CONTACT.phone}</p>
      <p className="text-sm">{CONTACT.email}</p>
    </div>
  </div>
);
